<template>
  <div>
    <div class="container-fluid m-0 p-0 mt-5">
      <div class="row justify-content-center pt-5">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 center">
          <img
            src="@/assets/Logo_Startseite.png"
            alt="CompTIA A+ Logo"
            class="img-fluid mb-3"
          />
        </div>
      </div>
      <div class="row justify-content-center pt-5">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 center">
          <router-link to="/kapitelfragen-quiz_A_Plus" class="nav-link"
            ><img src="@/assets/A+.png" alt="CompTIA A+ Logo" class="img-fluid mb-3"
          /></router-link>
        </div>
        
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 center">
          <router-link to="/kapitelfragen-quiz_N_Plus" class="nav-link"
            ><img src="@/assets/N+.png" alt="CompTIA N+ Logo" class="img-fluid mb-3"
          /></router-link>
        </div>
      </div>
      
    </div>

    <stickybarTelMail />
  </div>
  <stickyPfeil />
</template>

<script>
import fragenkatalog from "@/assets/Fragenkatalog/CompTIA_Aplus.json";

export default {
  name: "MainPage",

  data() {
    return {
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,

      Kurs: "Core1",
      AnzahlFragen: 10,

      // Progresswerte
      sekunden: 0, // 0..60 (loop)
      minuten: 0, // 0..AnzahlFragen (stop)

      // Timer
      laeuft: false,
      sekundenTimerId: null,
      minutenTimerId: null,

      // Quiz
      quizFragen: [],
      answers: {}, // { [id]: "A"|"B"|"C"|"D" }
      aktuelleFrageIndex: 0,
      quizFertig: false,

      // Auswahl pro aktueller Frage (wichtig für Reset!)
      selectedChoice: null,
      feedbackShown: false,
    };
  },

  computed: {
    sekundenProzent() {
      return (this.sekunden / 60) * 100;
    },
    minutenProzent() {
      const max = Number(this.AnzahlFragen) || 1;
      return (this.minuten / max) * 100;
    },
    minutenColor() {
      const max = Number(this.AnzahlFragen) || 1;
      const p = this.minuten / max;

      if (p >= 0.9) return "bg-danger"; // rot
      if (p >= 0.7) return "bg-warning"; // gelb
      return "bg-success"; // grün
    },

    aktuelleFrage() {
      return this.quizFragen[this.aktuelleFrageIndex] || null;
    },

    fragenProzent() {
      if (!this.quizFragen.length) return 0;
      return ((this.aktuelleFrageIndex + 1) / this.quizFragen.length) * 100;
    },

    richtigeAntworten() {
      let r = 0;
      for (const q of this.quizFragen) {
        if (this.answers[q.id] === q.correct) r++;
      }
      return r;
    },
    falschBeantwortete() {
      return this.quizFragen
        .filter((q) => this.answers[q.id] !== q.correct)
        .map((q) => ({
          ...q,
          given: this.answers[q.id] ?? null,
        }));
    },
    prozentRichtig() {
      if (!this.quizFragen.length) return 0;
      return Math.round((this.richtigeAntworten / this.quizFragen.length) * 100);
    },

    currentAnswerCorrect() {
      if (!this.aktuelleFrage || this.selectedChoice === null) return false;
      return this.selectedChoice === this.aktuelleFrage.correct;
    },

    bestehensProzent() {
      return 75; // Empfehlung für CompTIA-Style Training
    },

    mindestensRichtigZumBestehen() {
      if (!this.quizFragen.length) return 0;
      return Math.ceil((this.bestehensProzent / 100) * this.quizFragen.length);
    },

    statusText() {
      const p = this.prozentRichtig;

      if (p >= 90) return "🏆 Excellent";
      if (p >= this.bestehensProzent) return "✅ Bestanden";
      if (p >= 70) return "⚠️ Knapp daneben";
      return "❌ Nicht bestanden";
    },

    statusClass() {
      const p = this.prozentRichtig;

      if (p >= 90) return "alert-success";
      if (p >= this.bestehensProzent) return "alert-success";
      if (p >= 70) return "alert-warning";
      return "alert-danger";
    },
  },

  watch: {
    AnzahlFragen() {
      // Minutenanzeige resetten (optional)
      this.minuten = 0;

      // wenn bereits läuft, sauber neu starten
      if (this.laeuft) {
        this.stoppen();
        this.starten();
      }
    },
  },

  methods: {
    starten() {
      if (this.laeuft) return;
      this.laeuft = true;

      // Timer/Progress reset
      this.sekunden = 0;
      this.minuten = 0;

      // Quiz reset
      this.answers = {};
      this.quizFertig = false;
      this.aktuelleFrageIndex = 0;
      this.selectedChoice = null;
      this.feedbackShown = false;

      // Fragenpool
      const pool = fragenkatalog.questions.filter((q) => q.core === this.Kurs);
      const n = Math.min(Number(this.AnzahlFragen), pool.length);
      const shuffled = this.shuffle([...pool]);
      this.quizFragen = shuffled.slice(0, n);

      // Sekunden: jede Sekunde +1, bei 60 -> 0
      this.sekundenTimerId = window.setInterval(() => {
        this.sekunden = this.sekunden >= 60 ? 0 : this.sekunden + 1;
      }, 1000);

      // Minuten: jede Minute +1 bis AnzahlFragen, dann Quiz beenden
      this.minutenTimerId = window.setInterval(() => {
        const max = Number(this.AnzahlFragen) || 0;

        if (this.minuten >= max) {
          this.quizFertig = true;
          this.stoppen();
          return;
        }
        this.minuten += 1;
      }, 60000);
    },

    neuStarten() {
      this.stoppen();
      this.quizFragen = [];
      this.answers = {};
      this.quizFertig = false;
      this.aktuelleFrageIndex = 0;
      this.selectedChoice = null;
      this.feedbackShown = false;
    },

    antwortWaehlen() {
      const q = this.aktuelleFrage;
      if (!q || this.quizFertig || this.feedbackShown) return;

      // speichern und direkt Lösung anzeigen
      this.answers[q.id] = this.selectedChoice;
      this.feedbackShown = true;
    },

    naechsteFrage() {
      if (this.aktuelleFrageIndex < this.quizFragen.length - 1) {
        this.aktuelleFrageIndex += 1;
        this.selectedChoice = null;
        this.feedbackShown = false;
      } else {
        this.quizFertig = true;
        this.feedbackShown = false;
        this.stoppen();
      }
    },

    shuffle(arr) {
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
      return arr;
    },

    stoppen() {
      this.laeuft = false;

      if (this.sekundenTimerId) {
        clearInterval(this.sekundenTimerId);
        this.sekundenTimerId = null;
      }
      if (this.minutenTimerId) {
        clearInterval(this.minutenTimerId);
        this.minutenTimerId = null;
      }
    },
  },

  mounted() {
    window.onresize = () => {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
    };
  },

  beforeUnmount() {
    this.stoppen();
  },
};
</script>

<style scoped>
.progress-wrapper {
  position: relative;
}
.progress-text {
  position: absolute;
  width: 100%;
  text-align: center;
  font-weight: bold;
  line-height: 18px;
  color: black;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}
.progress-bar {
  transition: width 0.5s ease, background-color 0.5s ease;
}
</style>
